import React from 'react';
import { LucideIcon } from 'lucide-react';

interface BenefitCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  role?: string;
}

const BenefitCard: React.FC<BenefitCardProps> = ({ icon: Icon, title, description, role }) => (
  <div className="bg-white rounded-lg p-6 shadow-lg" role={role}>
    <div className="flex items-center mb-4">
      <Icon className="w-6 h-6 text-primary mr-3" />
      <h4 className="text-lg sm:text-xl font-bold">{title}</h4>
    </div>
    <p className="text-sm sm:text-base text-gray-600">{description}</p>
  </div>
);

export default BenefitCard; 